<template>
  <div fluid>
    <v-card tile elevation="0" color="transparent" class="white elevation-0">
      <p class="mr-2 text-h6 pl-2">직원조회</p>
      <v-data-table
        :headers="headers"
        :items="tableData"
        :items-per-page="15"
        class="elevation-0"
        @click:row="detailPage"
      >
        <template v-slot:item.leaveDay="{ item }">
          {{ `${item.restLeaveDay} / ${item.totLeaveDay}` }}
        </template>
        <template v-slot:item.leaveTime="{ item }">
          {{ `${item.restLeaveTime} / ${item.totLeaveTime}` }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { empData, empDetail, empList } from "@/api/employee.js";

export default {
  data() {
    return {
      search: "",
      align: "center",
      headers: [
        { text: "부서", align: "center", width: "200", value: "deptNm" },
        { text: "직급", align: "center", width: "100", value: "empRank" },
        { text: "이름", align: "center", width: "100", value: "empNm" },
        {
          text: "생년월일",
          align: "center",
          sortable: false,
          value: "birthDt",
        },
        { text: "이메일", align: "center", sortable: false, value: "email" },
        {
          text: "휴대폰번호",
          width: "150",
          align: "center",
          sortable: false,
          value: "mobile",
        },
        {
          text: "내선번호",
          width: "80",
          align: "center",
          sortable: false,
          value: "extensionTel",
        },
        {
          text: "휴가일\n(잔여휴가일/총휴가일)",
          width: "150",
          sortable: false,
          align: "center",
          value: "leaveDay",
        },
        {
          text: "휴가시간\n(잔여휴가시간/총휴가시간)",
          width: "200",
          sortable: false,
          align: "center",
          value: "leaveTime",
        },
        { text: "입사일", align: "center", value: "empJoinDt" },
      ],
      selectTeam: [],
      selectRank: [],
      tableData: [],
    };
  },
  async created() {
    try {
      const { data } = await empData();
      this.tableData = data.list;
    } catch (err) {
      console.log(err);
    }
    try {
      const { data } = await empList();
      this.selectTeam = data.deptList;
      this.selectRank = data.empRankList;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    searchClick() {
      console.log("search click");
    },
    resetClick() {
      console.log("reset");
    },
    async detailPage(event) {
      try {
        const { data } = await empDetail(event.empNo);
        const empNo = data.form.empNo;
        this.$router.push(`/employee/${empNo}`);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-card {
  white-space: pre-line;
}
</style>
